module.exports = __webpack_public_path__ + "img/img1.8bad4b15.png";